/* eslint-disable no-useless-concat */
/* eslint-disable prefer-template */
const getFormJSON = async (healthplan: string, serviceType: string, patientType: string) => {
  try {
    const formName = healthplan + '-' + serviceType + '-' + patientType + '.json';
    const response = await fetch(formName, { mode: 'no-cors' });
    const retVal = await response.json();
    return retVal;
  } catch (error) {
    // Log missing form name
    const response = await fetch(healthplan + '-' + 'general' + '-' + patientType + '.json', { mode: 'no-cors' });
    const retVal = await response.json();
    return retVal;
  }
};

const LoaderService = {
  getFormJSON,
};

export default LoaderService;
